import useWebReferrer from 'shared/utils/useWebReferrer';

/**
 * Handles one-time analytics setup when the app opens.
 * Rendered once below InitializationProvider, runs for all routes.
 *
 * Screen tracking has been moved to individual route group layouts
 * ((public)/_layout.tsx and (authenticated)/_layout.tsx) to ensure
 * authenticated screen events only fire after user identity is synced.
 */
const AnalyticsSetup = () => {
  useWebReferrer();

  return null;
};

export default AnalyticsSetup;
